import { SelectInput } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
}

const Title = ({ helper, optional, ...rest }: Props) => {
  const name = 'title'
  const label = 'Title'
  const options = [
    {
      label: 'Mr',
      value: 'Mr',
    },
    {
      label: 'Mrs',
      value: 'Mrs',
    },
    {
      label: 'Miss',
      value: 'Miss',
    },
    {
      label: 'Ms',
      value: 'Ms',
    },
    {
      label: 'Mx',
      value: 'Mx',
    },
    {
      label: 'Doctor',
      value: 'Doctor',
    },
    {
      label: 'Professor',
      value: 'Professor',
    },
    {
      label: 'Reverend',
      value: 'Reverend',
    },
  ]

  return (
    <SelectInput
      name={name}
      label={label}
      options={options}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default Title
